import { render } from "./jhjcBorder.vue?vue&type=template&id=ef64192c&scoped=true"
import script from "./jhjcBorder.vue?vue&type=script&lang=js"
export * from "./jhjcBorder.vue?vue&type=script&lang=js"

import "./jhjcBorder.vue?vue&type=style&index=0&id=ef64192c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef64192c"]])

export default __exports__